import { Label } from "./label.js";
import { LabelStyles, LabelTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Label component.
 *
 * @public
 */
export const definition = Label.compose({
    name: `${DesignSystem.prefix}-label`,
    template: LabelTemplate,
    styles: LabelStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=label.definition.js.map